// Add new project coverage here. Keep original publication dates, source URLs,
// historical project names and complete RU/EN summaries; do not copy full articles.
const PUBLICATIONS = [
  {
    id: 'business-cases-noesis',
    href: 'https://casejournal.ru/index.php/cj/article/view/41',
    datePublished: '2026-03-30',
    kind: 'journal',
    sourceTitle: 'Noesis: ИИ как ключ к осознанности',
    sourcePublisher: 'Бизнес-кейсы: менеджмент и маркетинг',
    ru: {
      category: 'Статья в журнале',
      title: 'Noesis: ИИ как ключ к осознанности',
      publisher: 'Бизнес-кейсы: менеджмент и маркетинг',
      dateLabel: '30 марта 2026',
      description: 'Наша статья о том, как появился проект и как искусственный интеллект помогает работать с личной информацией, освобождая время для решений и действий.',
      context: 'В статье проект представлен под прежним названием Noesis. Материал вышел в томе 2, № 4 за 2025 год; на сайте журнала опубликован 30 марта 2026 года.',
      action: 'Читать в журнале',
    },
    en: {
      category: 'Journal article',
      title: 'Noesis: AI as a key to mindfulness',
      publisher: 'Business Cases: Management and Marketing',
      dateLabel: '30 March 2026',
      description: 'Our article explores the origins of the project and how AI can help people work with personal information, leaving more time for decisions and action.',
      context: 'The article uses the project’s former name, Noesis. It appears in volume 2, issue 4 (2025), and was published on the journal’s website on 30 March 2026.',
      action: 'Read in the journal',
    },
  },
  {
    id: 'mgimo-neuro-startup-3',
    href: 'https://mgimo.ru/about/news/main/iii-neuro-startup/',
    secondaryHref: 'https://startup.mgimo.ai/#results',
    datePublished: '2025-11-25',
    kind: 'award',
    sourceTitle: 'Победители III конкурса студенческих бизнес-проектов «Нейро Стартап»',
    sourcePublisher: 'МГИМО',
    ru: {
      category: 'Победа в конкурсе',
      title: 'Первое место на «Нейро Стартап — 3» в МГИМО',
      publisher: 'Официальный сайт МГИМО',
      dateLabel: '25 ноября 2025',
      description: 'Проект, из которого выросла Noesa, занял первое место на третьем конкурсе студенческих бизнес-проектов «Нейро Стартап». Итоги опубликованы на официальном сайте МГИМО.',
      context: 'В новости использовано название конкурсного проекта — «Антисоцсеть на базе ИИ». Финал состоялся 24 ноября 2025 года.',
      action: 'Читать на сайте МГИМО',
      secondaryAction: 'На сайте конкурса',
    },
    en: {
      category: 'Competition award',
      title: 'First place at MGIMO’s Neuro Startup 3',
      publisher: 'MGIMO’s official website',
      dateLabel: '25 November 2025',
      description: 'The project that grew into Noesa won first place at the third Neuro Startup student business project competition. The results were published on MGIMO’s official website.',
      context: 'The announcement uses the competition project’s name, “AI-based anti-social network”. The final took place on 24 November 2025.',
      action: 'Read on MGIMO’s website',
      secondaryAction: 'Competition website',
    },
  },
];

const UI = {
  ru: {
    title: 'Публикации о Noesa — статьи и достижения проекта',
    description: 'Noesa в публикациях: статья в журнале «Бизнес-кейсы: менеджмент и маркетинг» и первое место на конкурсе «Нейро Стартап — 3» в МГИМО. Ссылки на первоисточники.',
    h1: 'Публикации о Noesa',
    navLabel: 'Публикации о Noesa',
    kicker: 'О проекте в публикациях',
    lead: 'Статьи о проекте, результаты конкурсов и важные этапы нашего пути. Собираем здесь материалы, к которым можно обратиться за подробностями.',
    panelTitle: 'История проекта',
    panelBody: 'Noesa развивалась под названием Noesis. В ранних публикациях встречаются прежнее название и описание конкурсного прототипа — это части одной истории.',
    listLabel: 'Публикации о проекте Noesa',
    sourceLanguage: 'Оригинал на русском',
    continued: 'Будем дополнять раздел новыми публикациями о Noesa.',
  },
  en: {
    title: 'Noesa in publications — articles and project milestones',
    description: 'Read about Noesa in Business Cases: Management and Marketing and the official results of MGIMO’s Neuro Startup 3 competition. Links to the original sources.',
    h1: 'Noesa in publications',
    navLabel: 'Noesa in publications',
    kicker: 'The project in print and online',
    lead: 'Articles about the project, competition results and milestones along the way. Explore the original publications for the full story.',
    panelTitle: 'Our story so far',
    panelBody: 'Noesa previously developed under the name Noesis. Early publications use that name or describe the competition prototype — they are part of the same story.',
    listLabel: 'Publications about Noesa',
    sourceLanguage: 'Original in Russian',
    continued: 'We’ll add new publications about Noesa as they appear.',
  },
};

function getPublications(language = 'ru') {
  const locale = language === 'en' ? 'en' : 'ru';
  return PUBLICATIONS.map(({ ru, en, ...source }) => ({ ...source, ...(locale === 'en' ? en : ru) }))
    .map((publication) => ({
      ...publication,
      references: [
        { href: publication.href, label: publication.action },
        ...(publication.secondaryHref && publication.secondaryAction
          ? [{ href: publication.secondaryHref, label: publication.secondaryAction }]
          : []),
      ],
    }))
    .sort((a, b) => b.datePublished.localeCompare(a.datePublished));
}

function getPublicationsUi(language = 'ru') { return UI[language === 'en' ? 'en' : 'ru']; }

module.exports = { getPublications, getPublicationsUi };
